import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import CustomButton from "components/CustomButton";
import {FormattedMessage} from "react-intl";
import {useSnackbar} from "notistack";

import MobileIconButton from "./MobileView/components/MobileIconButton";

import {DateRangePickerContext} from "contexts/DateRangePickerContext";

import {downloadExport} from "api/order/export";

ExportOrdersButton.propTypes = {
    compact: PropTypes.bool
};

const CompactIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 11.3333V7.33333L4.66667 8.66667" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6 7.33333L7.33333 8.66667" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6667 6.66667V10C14.6667 13.3333 13.3333 14.6667 10 14.6667H6C2.66667 14.6667 1.33333 13.3333 1.33333 10V6C1.33333 2.66667 2.66667 1.33333 6 1.33333H9.33333" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6667 6.66667H12C10 6.66667 9.33333 6 9.33333 4V1.33333L14.6667 6.66667Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

function ExportOrdersButton({compact = false}) {
    const {startDate, endDate} = useContext(DateRangePickerContext);
    const {enqueueSnackbar} = useSnackbar();

    async function handleClick() {
        try {
            await downloadExport(startDate, endDate);

            enqueueSnackbar(<FormattedMessage id="picking.order.list.export.success" />, {variant: 'success'});
        } catch {
            enqueueSnackbar(<FormattedMessage id="list.error" />, {variant: 'error'});
        }
    }

    return (
        compact ? (
            <MobileIconButton onClick={handleClick}>
                <CompactIcon />
            </MobileIconButton>
        ) : (
            <CustomButton color={'default'} variant={'outlined'} onClick={handleClick}>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <FormattedMessage id='oms.order.list.export.orders' />
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.00033 11.3333V7.33333L4.66699 8.66666" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 7.33333L7.33333 8.66666" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.6663 6.66666V9.99999C14.6663 13.3333 13.333 14.6667 9.99967 14.6667H5.99967C2.66634 14.6667 1.33301 13.3333 1.33301 9.99999V5.99999C1.33301 2.66666 2.66634 1.33333 5.99967 1.33333H9.33301" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.6663 6.66666H11.9997C9.99967 6.66666 9.33301 6 9.33301 3.99999V1.33333L14.6663 6.66666Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </CustomButton>
        )
    );
}

export default ExportOrdersButton;
